// extracted by mini-css-extract-plugin
module.exports = {"primary":"cta-module--primary--3l1iJ","secondary":"cta-module--secondary--21qXS","link":"cta-module--link--2Lq3r"};